import React from "react";
import {
  Switch,
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Spin,
  DatePicker,
  Select,
  Checkbox,
  Alert,
} from "antd";

const { Title } = Typography;

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const buttonItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 4,
  },
};

const ElectionForm = ({
  onChangehandle,
  onSubmit,
  editMode,
  onCancelEditMode,
  electionDetailsCollection
}) => {
  return (
    <div className="election-form">
      {electionDetailsCollection.length >= 1 && (
        <Alert
          message="Hello Admin, You can not add more election details because you've already added 1 election Details,
          If you want to add then please remove election Details!!!"
          type="info"
          showIcon
        />
      )}
      <Form {...formItemLayout}>
        <Title level={3} style={{ marginLeft: "10%" }}>
          {false ? "Update" : "Add"} Election Details
        </Title>
        <Form.Item label="Title">
          <Input
            onChange={({ target }) => onChangehandle(target.value, "title")}
            // value={title}
            placeholder="Enter Article Title"
            name="title"
            disabled={electionDetailsCollection.length >= 1}
          />
        </Form.Item>
       
        <Form.Item label="Sub Title">
          <Input
            onChange={({ target }) => onChangehandle(target.value, "subTitle")}
            placeholder="Enter Sub Title"
            name="subTitle"
            disabled={electionDetailsCollection.length >= 1}
          />
        </Form.Item>
        
        <Form.Item label="Description">
          <Input
            onChange={({ target }) => onChangehandle(target.value, "description")}
            placeholder="Enter Description"
            name="description"
            disabled={electionDetailsCollection.length >= 1}
          />
        </Form.Item>

        <Form.Item label="Election Status">
          <Switch
            onChange={(value) => onChangehandle(value, "electionState")}
            disabled={electionDetailsCollection.length >= 1}
          />
        </Form.Item>

        <Form.Item {...buttonItemLayout}>
          {!editMode ? (
            <Button
              onClick={onSubmit}
              type="primary"
              style={{
                background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
              }}
              disabled={electionDetailsCollection.length >= 1}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={onSubmit}
              type="primary"
              style={{
                background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
              }}
            >
              Update
            </Button>
          )}
          {editMode && (
            <Button
              style={{ marginLeft: 20 }}
              onClick={onCancelEditMode}
              type="ghost"
            >
              Cancel
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  )
}

export default ElectionForm;
